export const normalizePhoneNumber = (value) => {
  if (!value) {
    return "";
  }

  return value.replace(/[\D]/g, ''). // only numbers
    slice(0, 10); // only 10 of them
};

export const formatPhoneNumber = (value) => {
  if (!value) {
    return "";
  }

  // Normalize the phone number first (remove all non-digit characters)
  const normalized = normalizePhoneNumber(value);

  if (normalized.length <= 3) {
    return normalized;
  }

  if (normalized.length <= 6) {
    return `(${normalized.slice(0, 3)}) ${normalized.slice(3)}`;
  }

  return `(${normalized.slice(0, 3)}) ${normalized.slice(3, 6)}-${normalized.slice(6, 10)}`;
};
